module.exports = __webpack_public_path__ + "img/accountant_creditor.70715670.png";